<div class="flex flex-col items-center mx-8">
  <h1 class="text-4xl my-1">{{ message('outputsHeader') }}</h1>
  <mat-form-field appearance="outline" floatLabel="always" class="w-full my-1">
    <mat-label>{{ message('recipeSearchPlaceholder') }}</mat-label>
    <input #recipeInput matInput type="text" aria-label="Search for a recipe to add"
           (input)="onRecipeInput(recipeInput.value)"
           [matAutocomplete]="recipesAutocomplete">
  </mat-form-field>
  <mat-autocomplete #recipesAutocomplete="matAutocomplete" class="max-h-[70vh]"
                    (optionSelected)="onRecipeSelected($event.option, recipeInput)">
    @for (recipe of filteredRecipes(); track recipe.nameID) {
      <mat-option [value]="recipe">
        {{ recipe.name() }}
      </mat-option>
    }
  </mat-autocomplete>
  <div class="flex flex-col w-full text-sm selected-outputs-container my-1">
    @for (displayGroup of groupedDisplayKeys(); track displayGroup) {
      <mat-expansion-panel togglePosition="before" [expanded]="$first" class="my-1">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ displayGroup.name() }}</mat-panel-title>
          <mat-icon [attr.aria-label]="'Remove ' + displayGroup.name() + ' skill group'"
                   (click)="onRemoveSkill(displayGroup)">close</mat-icon>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
        @for (outputDisplay of groupedOutputDisplays().get(displayGroup); track outputDisplay.itemNameID) {
          <div class="output-container my-1 pl-1 py-2 rounded">
            <div class="flex flex-row items-center w-full">
              <img [src]="imageService.imageTemplateUrl" [style]="imageService.getOutputImgStyle(outputDisplay)"
                   width="32" height="32" [alt]="outputDisplay.itemName() + ' icon'" class="mr-2">
              <span class="font-medium">
                {{ outputDisplay.itemName() }}
              </span>
              @if (outputDisplay.subRecipes.length === 1) {
                <button class="material-icons cursor-pointer hover:opacity-80 ml-1"
                        [attr.aria-label]="outputDisplay.itemName() + ' recipe details'"
                        (click)="onRecipeInfoClick(outputDisplay.subRecipes[0])">info_outline
                </button>
              }
              <div class="ml-auto flex items-center">
                <div class="readonly-field w-24 mr-4"
                     [attr.aria-label]="outputDisplay.itemName() + ' base cost'">
                  <span class="readonly-label">{{ message('baseCostLabel') }}</span>
                  <span>{{ outputDisplay.basePrice() | localeNumber:localeService.selectedLocale().code }}</span>
                </div>
                <mat-form-field appearance="outline" floatLabel="always" class="w-24 mr-4">
                  <mat-label>{{ message('profitLabel') }}</mat-label>
                  <input #profitOverride matInput type="number" min="0" step="1" class="profit-input"
                         [attr.aria-label]="outputDisplay.itemName() + ' profit %'"
                         [value]="outputDisplay.subRecipes[0].recipe.profitOverride() >= 0 ? outputDisplay.subRecipes[0].recipe.profitOverride() : defaultProfitPercent()"
                         (focusout)="onProfitOverrideChange(profitOverride.value, outputDisplay)"
                  >
                  <span matSuffix>%</span>
                </mat-form-field>
                <div class="readonly-field w-24 mr-4"
                     [attr.aria-label]="outputDisplay.itemName() + ' sale price'">
                  <span class="readonly-label">{{ message('salePriceLabel') }}</span>
                  <span>{{ outputDisplay.itemPrice() | localeNumber:localeService.selectedLocale().code }}</span>
                </div>
                <button class="material-icons cursor-pointer hover:opacity-80 mr-2"
                        [attr.aria-label]="'Remove ' + outputDisplay.itemName()"
                        (click)="onRemoveOutput(outputDisplays().indexOf(outputDisplay))">
                  close
                </button>
              </div>
            </div>
            @if (outputDisplay.subRecipes.length > 1) {
              @for (subRecipe of outputDisplay.subRecipes; track subRecipe.recipeNameID; let subIndex = $index) {
                <div class="flex flex-row items-center w-full pl-8 mt-3">
                  <span class="pl-6">
                    {{ subRecipe.recipeName() }} {{ message('recipeSuffix') }}
                  </span>
                  <button class="material-icons cursor-pointer hover:opacity-80 ml-1"
                          [attr.aria-label]="subRecipe.recipeName() + ' recipe details'"
                          (click)="onRecipeInfoClick(subRecipe)">
                    info_outline
                  </button>
                  <div class="ml-auto flex items-center">
                    <div class="readonly-field w-24 mr-4"
                         [attr.aria-label]="subRecipe.recipeName() + ' base cost'">
                      <span class="readonly-label">{{ message('baseCostLabel') }}</span>
                      <span>{{ subRecipe.basePrice() | localeNumber:localeService.selectedLocale().code }}</span>
                    </div>
                    <button class="material-icons cursor-pointer hover:opacity-80 mr-2"
                            [attr.aria-label]="'Remove ' + subRecipe.recipeName() + ' recipe'"
                            (click)="onRemoveSubRecipe(outputDisplays().indexOf(outputDisplay), subIndex)">
                      close
                    </button>
                  </div>
                </div>
              }
            }
          </div>
        }
        </ng-template>
      </mat-expansion-panel>
    }
    <!--
    @for (outputDisplay of outputDisplays(); track outputDisplay.itemNameID; let outputIndex = $index) {
      <div class="output-container my-1 pl-1 py-2 rounded">
        <div class="flex flex-row flex-wrap items-center w-full">
          <img [src]="imageService.imageTemplateUrl" [style]="imageService.getOutputImgStyle(outputDisplay)"
               width="32" height="32" [alt]="outputDisplay.itemName() + ' icon'" class="mr-2">
          <label [for]="outputCost.id" class="font-medium">
            {{ outputDisplay.itemName() }}
          </label>
          @if (outputDisplay.subRecipes.length === 1) {
            <button class="material-icons cursor-pointer hover:opacity-80 ml-1"
                    (click)="onRecipeInfoClick(outputDisplay.subRecipes[0])">info_outline</button>
          }
          <div class="ml-auto flex items-center">
            <mat-form-field appearance="outline" class="w-24 mr-4">
              <input #outputCost matInput type="text" readonly class="cursor-not-allowed"
                     [value]="outputDisplay.itemPrice().toLocaleString(localeService.selectedLocale().code,
                 {maximumFractionDigits: 2, minimumFractionDigits: 0})">
            </mat-form-field>
            <button class="material-icons cursor-pointer hover:opacity-80 mr-2"
                    (click)="onRemoveOutput(outputIndex)">
              close
            </button>
          </div>
        </div>
        @if (outputDisplay.subRecipes.length > 1) {
          @for (subRecipe of outputDisplay.subRecipes; track subRecipe.recipeNameID; let subIndex = $index) {
            <div class="flex flex-row flex-wrap items-center w-full pl-8 mt-1">
              <label class="pl-6" [for]="subRecipePrice.id">
                {{ subRecipe.recipeName() }} Recipe
              </label>
              <button class="material-icons cursor-pointer hover:opacity-80 ml-1"
                      (click)="onRecipeInfoClick(subRecipe)">
                info_outline
              </button>
              <div class="ml-auto flex items-center">
                <mat-form-field appearance="outline" class="w-24 mr-4">
                  <input #subRecipePrice matInput type="text" readonly class="cursor-not-allowed"
                         [value]="subRecipe.recipePrice().toLocaleString(localeService.selectedLocale().code,
                   {maximumFractionDigits: 2, minimumFractionDigits: 0})">
                </mat-form-field>
                <button class="material-icons cursor-pointer hover:opacity-80 mr-2"
                        (click)="onRemoveSubRecipe(outputIndex, subIndex)">
                  close
                </button>
              </div>
            </div>
          }
        }
      </div>
    }
    -->
    </div>
</div>
